// extracted by mini-css-extract-plugin
export default {"Slide":"styles_Slide__c--O7","content":"styles_content__Ndb2K","slideUpFadeIn":"styles_slideUpFadeIn__lgTkp","text":"styles_text__fccEF"};